import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrEmpty } from '@awp/core/utils';

@Pipe({
  name: 'first',
  pure: true
})
export class FirstPipe implements PipeTransform {

  transform(value: Array<any>, key: string, filterValue: string, defaultValue?: any) {
    if (value != null && Array.isArray(value)) {
      if (!isNullOrEmpty(key) && !isNullOrEmpty(filterValue)) {
        const result = value.filter(p => p[key] === filterValue);
        return result != null && result.length >= 1 ? result[0] : defaultValue;
      } else if (value.length > 0) {
        return value[0];
      }
    }

    return defaultValue;
  }
}
